// aiservice.js
import axios from "axios";

const PROXY_URL = "https://bingemyai.net/myapi.php"; // your PHP proxy

export const getOpenAIResponse = async (message) => {
  try {
    const { data } = await axios.post(
      PROXY_URL,
      {
        model: "gpt-4o-mini",
        // IMPORTANT: system instruction + JSON mode
        messages: [
          {
            role: "system",
            content:
              'Return ONLY valid JSON. No prose, no backticks. Shape: {"items": [ { "title": string, "previewLink": string } ] }.',
          },
          { role: "user", content: message.trim() },
        ],
        temperature: 0, // reduce creativity; fewer formatting surprises
        response_format: { type: "json_object" }, // enforce valid JSON
      },
      { headers: { "Content-Type": "application/json" } }
    );

    // message.content will be a JSON string; parse it
    const content = data.choices[0].message.content;
    const obj = JSON.parse(content);
    return JSON.stringify(obj.items ?? []); // keep your caller API the same
  } catch (error) {
    console.error("❌ Proxy error:", error.response?.status, error.response?.data || error.message);
    return JSON.stringify([{ title: "Error fetching response", previewLink: "#" }]);
  }
};
